import { FixedInfoBannerVariant } from '@kanda-libs/ks-design-library';
import { FinanceProvider } from '@kanda-libs/ks-frontend-services';

export const VARIANTS: Record<FinanceProvider, FixedInfoBannerVariant> = {
  omni: 'blue',
  omni_lv: 'blue',
  omni_re: 'blue',
  etika: 'orange',
  propensio: 'violet',
  allium: 'dark-grey',
  novuna: 'green',
  humm: 'red',
  humm_re: 'red',
  demo: 'grey',
};
